import * as ENDPOINTS from '@/common/constants/endpoints'

import { api } from '../api'

export const checkStatus = async (qrCode: string): Promise<QrCodeStatusResponse | undefined> =>
  api<QrCodeStatusResponse>(ENDPOINTS.GET_CHALLENGE, { method: 'GET', headers: { qrcode: qrCode } })
